/**
 * Trigger a browser file download from an already-fetched Blob (e.g. BE CSV/XLSX export).
 *
 * Same anchor-click pattern as {@link triggerCsvDownload}, but accepts a Blob + MIME-agnostic
 * filename so role/user permission exports (TROC-349 / TROC-350) can reuse one helper.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);

  URL.revokeObjectURL(url);
}

/**
 * Parses `filename=` / `filename*=` from a Content-Disposition header value.
 * Returns null when the header is missing or unparseable.
 */
export function parseFilenameFromContentDisposition(header: string | undefined | null): string | null {
  if (!header) {
    return null;
  }

  const utf8Match = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^["']|["']$/g, ''));
    } catch {
      return utf8Match[1].trim().replace(/^["']|["']$/g, '');
    }
  }

  const plainMatch = /filename\s*=\s*("?)([^";]+)\1/i.exec(header);
  if (plainMatch?.[2]) {
    return plainMatch[2].trim();
  }

  return null;
}
